// extracted by mini-css-extract-plugin
export default {"card":"F4Ka8C","radioInput":"Z2uPUD","selected":"eKi6CE","image":"_UT0iC","heading":"sxTsbj","description":"GraQBw","label":"fmiWFB"};